
































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import CardContainer from "@/components/CardContainer.vue";
import CartSummary from '@/components/CartSummary.vue';
import SummaryLine from "@/components/SummaryLine.vue";
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import { payWithTinaba, getTinabaPayUrl } from '@/common/TinabaPay'
import TinabaPay from '@/components/TinabaPay.vue';
import PaymentBase from './PaymentBase'
import PaypalPay from './PaypalPay.vue'
import PaypalCardPay from './PaypalCardPay.vue'
import PaymentButton from './PaymentButton.vue'

const TINABA_PAY = 'TINABA_PAY'
const PAYPAL_CARD = 'PAYPAL_CARD'

@Component({
  components: {
    TinabaPay,
    PaypalCardPay,
    PaypalPay,
    PaymentButton,
  }
})
export default class PaymentMethods extends PaymentBase {
  @Prop({ default: null }) readonly merchant!: MerchantStore;
  @Prop({ default: false }) readonly disabled!: boolean;
  @Prop({ default: false }) readonly onSelectedPayment!: any;

  selectedPayment: string | null = null
  loading = true
  paymentMethods: MerchantPaymentMethods | null = null

  cardEligible () {
    return window.paypal.HostedFields.isEligible()
  }

  async startCheckout(cb : any = () => {})
  {
    return this.createCheckoutAndProcess(cb)
  }

  handleCancel () {
    this.selectedPayment = null
  }

  handlePaypalCard () {
    this.selectedPayment = PAYPAL_CARD
  }

  async handleTinabaPay () {

    if(this.onSelectedPayment)
    {
      this.onSelectedPayment(TINABA_PAY);
    }

    await this.startCheckout()
    if (!this.tinanaPayPayload) return null
    if (payWithTinaba(this.tinanaPayPayload) === false) {
      this.selectedPayment = TINABA_PAY
    }
  }

  async fetchPaymentMethods () {
    const data = await this.$tinabaAPI.$vas.getVasPaymentMethods(this.merchant.businessId, this.merchant.shopId)
    this.paymentMethods = data
    this.loading = false
  }

  async created () {
    await this.fetchPaymentMethods()
    await this.fetchPaypalDetails()
    this.initPolling()
  }

  beforeDestroy() {
    this.stopPolling()
  }
}
